export const colors = {
  bgBase: '#0a0e14',
  bgSurface: '#131922',
  bgElevated: '#1a2230',
  borderSubtle: '#1f2937',
  borderStrong: '#2d3a4f',

  primary400: '#4a90c8',
  primary500: '#1e6091',
  primary600: '#154866',
  primary700: '#0e3147',

  accent400: '#fbbf24',
  accent500: '#f59e0b',
  accent600: '#d97706',

  alert400: '#f87171',
  alert500: '#ef4444',
  alert600: '#dc2626',

  success400: '#34d399',
  success500: '#10b981',
  success600: '#059669',

  textPrimary: '#e6e6e6',
  textSecondary: '#9ca3af',
  textMuted: '#6b7280',
} as const
